import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../types";

const initialState: RootState['devices'] = {
  devices: []
};

const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setDevices(state, action) {
      state.devices = action.payload;
    }
  }
});

export const { setDevices } = deviceSlice.actions;

export default deviceSlice.reducer;